import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import boxer100 from "../../images/boxer.jpg";
import "../../../src/product.css"; // Import the product.css file for styling


const Boxer100 = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}
        
            <h2 id="title">BOXER 100cc</h2>
        <section className="product-hero">
          
          <div className="product-image-wrapper">
            <img
              src={boxer100}
              alt="Bajaj Boxer 100cc"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              Boxer 100 is an accessible commuter bike designed for both
              intra-city travel and longer journeys. A motorcycle that is as
              strong as it is fuel efficient, and as comfortable as it is
              reliable.
            </p>

          </div>
        </section>

        {/* Specifications */}
        <section className="product-specifications">
          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">
            <div className="spec-card">
              <span>Engine Type</span>
              <strong>4 Stroke Engine</strong>
            </div>

            <div className="spec-card">
              <span>Cubic Capacity</span>
              <strong>99.27 cc</strong>
            </div>

            <div className="spec-card">
              <span>Transmission</span>
              <strong>Manual</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Type</span>
              <strong>Petrol</strong>
            </div>

            <div className="spec-card">
              <span>Battery</span>
              <strong>12V</strong>
            </div>

            <div className="spec-card">
              <span>Weight</span>
              <strong>109 kg</strong>
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Boxer100;